module.exports = __webpack_public_path__ + "static/media/prometheantemples.1e29b571.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/prometheantemples.png
 ** module id = 292
 ** module chunks = 0
 **/